export const DS_FORM_FIELD_CLASSES = {
  Root: "ds-form-field",
  HelperText: "ds-form-field__helper-text",
  InlineAction: "ds-form-field__inline-action",
} as const;
